export const environment = {
    production: false,
    apiEndpoint: 'https://test-userservice.vlinkgroup.net/api'
};
